import React, { useState } from "react";
import axios from "../../axios";
import urls from "../../Utils/urls";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import FormBox from "../FormBox/FormBox";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { LoadingButton } from "../../Utils/CustomComponent";
import { useSelector } from "react-redux";
import DragAndDrop from "../Tools/Helper-Components/DragAndDrop";
import axiosInstance from "axios";
import { selected_authentication_server } from "../../deployment-config";

const jsonHeaders = {
  "Content-Type": "application/json",
  Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
  maxBodyLength: Infinity,
};

const CreateTicketWithAttachments = ({ close }) => {
  const [loading, setLoading] = useState(false),
    [file, setFile] = useState([]);
  const accountOptions = useSelector((s) => s.account.accountOptions);
  const selectedRole = useSelector((s) => s.account.selectedRole.value);
  const userDetails = JSON.parse(localStorage.getItem("accessed_user"));

  const schema = Yup.object().shape({
    subject: Yup.string().required("Subject is mandatory"),
    incident_description: Yup.string().required("Description is mandatory"),
    // account: Yup.string().required("Account is mandatory"),
  });
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const handleAttachmentSubmit = (incident_number, incidentId) => {
    setLoading(true);
    const toastId = toast.loading("Document upload in progress...");
    //   sanitizedFileName = file[0].name.replace(/ /g, "_"),
    //   formData = new FormData();
    // formData.append("document", file[0], sanitizedFileName);
    // formData.append("incident_number", incident_number);
    // formData.append("created_by", userDetails);

    // axios
    //   .post(urls.support.postUploadAttachments, formData, {
    //     headers: { "Content-Type": "multipart/form-data" },
    //   })
    //   .then((res) => {
    //     if (res.status === 200)
    //       axiosInstance.post(
    //         selected_authentication_server.ticket_attachment.endpoint,
    //         {
    //           incident_name: incident_number,
    //           filename: res.data.filename,
    //           incident_id: incidentId,
    //           mime_type: file[0].type,
    //           comment: "",
    //           created_by: userDetails.email,
    //         },
    //         selected_authentication_server.ticket_attachment.headers
    //       );
    //     toast.update(toastId, {
    //       render: "Document Uploaded Successfully",
    //       type: "success",
    //       isLoading: false,
    //       ...commonToast,
    //     });
    //     close();
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //     toast.update(toastId, {
    //       render: "SOME ERROR OCCURED",
    //       type: "error",
    //       isLoading: false,
    //       ...commonToast,
    //     });
    //   })
    //   .finally(() => setTimeout(() => toast.dismiss(), 3000));

    const uploadPromises = file?.map((singleFile) => {
      const sanitizedFileName = singleFile.name.replace(/ /g, "_");

      const formData = new FormData();
      formData.append("document", singleFile, sanitizedFileName);
      formData.append("incident_number", incident_number);
      formData.append("created_by", userDetails);

      return axios
        .post(urls.support.postUploadAttachments, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.status === 200) {
            return axiosInstance.post(
              selected_authentication_server.ticket_attachment.endpoint,
              {
                incident_name: incident_number,
                filename: response.data.filename,
                incident_id: incidentId,
                mime_type: singleFile.type,
                comment: "",
                created_by: userDetails.email,
              },
              selected_authentication_server.ticket_attachment.headers
            );
          }
        });
    });

    Promise.all(uploadPromises)
      .then(() => {
        toast.update(toastId, {
          render: "Document(s) uploaded successfully",
          type: "success",
          isLoading: false,
          ...commonToast,
        });
        close();
      })
      .catch((err) => {
        console.error(err);
        toast.update(toastId, {
          render: "Some error occurred during upload",
          type: "error",
          isLoading: false,
          ...commonToast,
        });
      })
      .finally(() => {
        setFile([]);
        setLoading(false);
        setTimeout(() => toast.dismiss(toastId), 3000);
      });
  };

  const onSubmit = (data) => {
    if (!file?.length)
      return toast.error("File attachment is mandatory", commonToast);
    Object.assign(data, {
      user_id: `${userDetails.user_id}`,
      contact_email: userDetails.email,
      status_id: "1",
      role_type: selectedRole,
      severity_id: "",
      urgency_id: "",
      department_id: "1",
      category_id: "58370845810097146125218097464265568365",
    });
    axios
      .post(urls.support.postTicket(), data, { headers: jsonHeaders })
      .then(({ data: resData }) => {
        const { incident_number } = resData;
        if (incident_number) {
          const incident_id = JSON.parse(resData.incident_id).incident_id;
          handleAttachmentSubmit(incident_number, incident_id);
        }
      })
      .catch(console.error);
  };

  function handleClose() {
    setFile([]);
    reset();
    close();
  }

  const ticketFormArr = [
    { title: "Subject", field: "subject", type: "text", className: "col-12" },
    {
      title: "Description",
      field: "incident_description",
      type: "textarea",
      className: "col-12",
    },
    {
      title: "Account",
      field: "account",
      type: "select",
      options: accountOptions,
      className: "col-12",
      blur: true,
    },
  ];

  return (
    <div className="mt-2">
      <form className="py-5 bg-white" onSubmit={handleSubmit(onSubmit)}>
        <div className="">
          <div className="row">
            <div className="col-12 mb-4">
              <FormBox
                options={ticketFormArr}
                register={register}
                watch={watch}
                setValue={setValue}
                errors={errors}
              />
            </div>
          </div>
        </div>
        <DragAndDrop files={file} setFiles={setFile} />
        <div className="d-flex justify-content-end mt-5">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
          >
            Cancel
          </button>
          <LoadingButton
            loading={loading}
            disabled={loading}
            type="submit"
            className="btn btn-primary text-white"
            title={"Add Attachments"}
          />
        </div>
      </form>
    </div>
  );
};

export default CreateTicketWithAttachments;
